<template>
  <div class="ma-4">
  <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <div class="text-h4" v-if="edicao !== 'true'">Cadastro de Departamento</div>

      <v-form ref="form" class="mt-4">
        <v-row>
          <v-col>
            <v-text-field
              outlined
              dense
              label="Descrição"
              counter="30"
              v-model="form.description"
              :disabled="permissaoVisualizar"
              :error-messages="descriptionErrors"
              @input="$v.form.description.$touch()"
              @blur="$v.form.description.$touch()"
            />
          </v-col>
          <v-col>
            <v-text-field
              outlined
              dense
              label="Código"
              v-model="form.codigo"
              :disabled="permissaoVisualizar"
              :error-messages="codigoErrors"
              @input="$v.form.codigo.$touch()"
              @blur="$v.form.codigo.$touch()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              dense
              v-model.number="form.qtCallsDaily"
              type="number"
              label="Ligações Diárias"
              outlined
              :counter="15"
              :error-messages="qtCallsDailyErrors"
              @input="$v.form.qtCallsDaily.$touch()"
              @blur="$v.form.qtCallsDaily.$touch()"
            />
          </v-col>
          <v-col>
            <v-text-field
              dense
              v-model.number="form.qtCallsWeekly"
              type="number"
              label="Ligações Semanais"
              outlined
              :counter="15"
              :error-messages="qtCallsWeeklyErrors"
              @input="$v.form.qtCallsWeekly.$touch()"
              @blur="$v.form.qtCallsWeekly.$touch()"
            />
          </v-col>
          <v-col>
            <v-text-field
              dense
              v-model.number="form.qtCallsMonthly"
              type="number"
              label="Ligações mensais"
              outlined
              :counter="15"
              :error-messages="qtCallsMonthlyErrors"
              @input="$v.form.qtCallsMonthly.$touch()"
              @blur="$v.form.qtCallsMonthly.$touch()"
            />
          </v-col>
        </v-row>
        <FixedButtons
          @salvar="salvar"
          @cancelar="cancelar"
          :pararLoader="pararLoader"
          :disableSaveButton="permissaoVisualizar"
        />
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { validationMixin } from 'vuelidate'

import { registerVuexModule } from '@/utils/vuexUtils'
import FixedButtons from '@/componentes/FixedButtons'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'
import Snackbar from '@/componentes/Snackbar'

import departamentoStore from '../_store'
import { validateData, validateComputed } from '../_validates/validatesDepartamentos'
import departamentosHttpService from '../_services/departamentosHttpService'

export default {
  props: {
    edicao: String,
    _id: String,
  },

  components: { Snackbar, FixedButtons },
  mixins: [validationMixin],

  data: () => ({
    text: '',
    snackbar: false,
    form: {
      description: '',
      codigo: '',
      qtCallsDaily: 0,
      qtCallsWeekly: 0,
      qtCallsMonthly: 0,
    },
    showSkeleton: false,
    permissaoVisualizar: false,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('atualizarDepartamentoModuleCallCenterStore', ['getDepartamentoEspecifico']),
  },

  async created() {
    registerVuexModule(this.$store, 'atualizarDepartamentoModuleCallCenterStore', departamentoStore)

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    if (arrayPermissions.includes(process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_VISUALIZAR_CONDICIONADO)) {
      this.permissaoVisualizar = true
    }

    if (this.edicao === 'true') {
      this.form = Object.assign({}, this.getDepartamentoEspecifico)
    }
    

    this.showSkeleton = false
  },

  methods: {
    ...obtainUserPermissions,

    cancelar() {
      this.$router.push({ name: 'Departamento' })
    },

    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      try {
        if (this.edicao === 'true') {
          await departamentosHttpService.putDepartamento(this._id, this.form)
        } else {
          await departamentosHttpService.postDepartamento(this.form)
        }
        this.$router.push({ name: 'Departamento' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
  },
}
</script>
